import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const RentedInvoiceForm = (props) => {
  const [loading, setLoading] = useState(false);

  var d = new Date();

  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [lastMaintenanceDate, setLastMaintenanceDate] = useState();
  // new Date().toISOString().substr(0, 10)

  const handleLastMaintenanceChange = (e) => {
    setLastMaintenanceDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const [currancys, setCurrancys] = useState([]);
  const [currencyId, setCurrencyId] = useState([]);

  const [taxs, setTaxs] = useState();
  const [taxId, setTaxId] = useState();
  const [taxAmount, setTaxAmount] = useState(0);
  const [vendorId, setvendorId] = useState(0);

  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          setCurrancys(res);
          //console.log(res);
        }
      }
    );
  }, [getCurrency]);
  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  const frmRef = useRef({});
  const { sendRequest: postRentedVmeInvoice } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);

    const data = {
      rvmeiDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      timeStamp: frmRef.current.time_stamp.value,
      supervisorEmployeeId: frmRef.current.emp_id.value,
      vendorName: frmRef.current.vendor_name.value,
      vendorId: vendorId,
      vmeClassification: frmRef.current.vme_classification.value,
      vmeModelName: frmRef.current.modal_name.value,
      vmeType: frmRef.current.vme_category.value,
      vmeNo: frmRef.current.vme_number.value,
      vmeYear: frmRef.current.manufacturing_year.value,
      lastMaintenenceDate: moment(
        frmRef.current.last_maintenance_date.value
      ).format("DD/MM/YYYY"),
      serviceDealType: frmRef.current.service_deal_type.value,
      rentCost: frmRef.current.rent_cost.value,
      currencyId: frmRef.current.currency.value,
      discount: frmRef.current.discount.value,
      discountAmt: frmRef.current.discount_amt.value,
      totalAmt: frmRef.current.total_amount.value,
      taxId: frmRef.current.tax.value,
      taxAmount: frmRef.current.tax_amt.value,
      totalWorkServiceOrdervalue: frmRef.current.total_work_value.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      createdDate: dateString,
      serviceId: props.sId,
    };
    //console.log(data);
    if (props.update) {
      data["rvmeiId"] = props.update.rvmeiId;
    }
    postRentedVmeInvoice(
      {
        url: "/api/rentedMEVInvoice/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(
          `Rented Invoice sucessfully ${props.update ? "updated" : "added!"}`
        );
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  const { sendRequest: getEmp } = useHttp();
  const [employeeId, setEmployeeId] = useState();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);
  const [vendorDetails, setVendorDetails] = useState([]);
  const { sendRequest: getLoadVendor } = useHttp();

  const { sendRequest: getVendor } = useHttp();

  const loadVendorData = (id) => {
    frmRef.current.vendor_id.value = "";
    frmRef.current.vendor_name.value = "";

    getLoadVendor(
      {
        url: `/api/addVendor/?vendorId=${id}`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          frmRef.current.vendor_id.value = res.vendorCode;
          frmRef.current.vendor_name.value = res.vendorName || "";
          frmRef.current.contact_person_name.value =
            res.contactPersonName || "";
          frmRef.current.work_contact.value = res.contactWork || "";
          frmRef.current.whatsapp_contact.value = res.whatsapp || "";
          frmRef.current.email.value = res.email || "";
        }
      }
    );
  };

  useEffect(() => {
    getVendor(
      {
        url: `/api/getVendorNames/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setVendorDetails(res);
        }
      }
    );
  }, [getVendor]);

  useEffect(() => {
    if (props.update) {
      console.log("props.update", props.update);
      frmRef.current.date.value = moment(props.update.vmerDate).format(
        "YYYY-MM-DD"
      );

      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      frmRef.current.remark.value = props.update.remark;

      frmRef.current.vendor_name.value = props.update.vendorName;
      frmRef.current.vendor_id.value = props.update.vendorId;
      setvendorId(props.update.vendorId);
      loadVendorData(props.update.vendorId);
      frmRef.current.vme_classification.value = props.update.vmeClassification;
      frmRef.current.modal_name.value = props.update.vmeModelName;
      frmRef.current.vme_category.value = props.update.vmeType;
      frmRef.current.vme_number.value = props.update.vmeNo;
      frmRef.current.manufacturing_year.value = props.update.vmeYear;

      frmRef.current.service_deal_type.value = props.update.serviceDealType;
      frmRef.current.rent_cost.value = props.update.rentCost;
      frmRef.current.currency.value = props.update.currencyId;
      frmRef.current.tax.value = props.update.taxId;
      setCurrencyId(props.update.currencyId);
      setTaxId(props.update.taxId);

      console.log("Tax added");
      frmRef.current.discount.value = props.update.discount;
      frmRef.current.discount_amt.value = props.update.discountAmt;
      frmRef.current.total_amount.value = props.update.totalAmt;
      console.log("discount_amt added", frmRef.current.discount_amt.value);
      frmRef.current.total_work_value.value =
        props.update.totalWorkServiceOrdervalue;
      frmRef.current.last_maintenance_date.text =
        props.update.lastMaintenenceDate;
      console.log(
        "last_maintenance_date added",
        frmRef.current.last_maintenance_date.text
      );
      setLastMaintenanceDate(props.update.lastMaintenenceDate);
      // moment(
      //     props.update.lastMaintenenceDate
      //   ).format("YYYY-MM-DD");
      setTotalValue({
        ...total,
        taxId: props.update.taxId,
        rentCost: props.update.rentCost,
        dispercentage: props.update.discount,
      });
    }
  }, [props.update]);

  const [total, setTotalValue] = useState({
    dispercentage: 0,
    taxId: 0,
    rentCost: 0,
  });

  useEffect(() => {
    var rentCost = 0;
    var discountAmount = 0;
    var amountafterdiscount = 0;

    ////console.log(total.dispercentage);
    rentCost = parseFloat(total.rentCost);

    discountAmount = (rentCost * parseFloat(total.dispercentage)) / 100 || 0;
    discountAmount = discountAmount.toFixed(2);

    amountafterdiscount = rentCost - discountAmount;

    frmRef.current.discount_amt.value = discountAmount;

    frmRef.current.total_amount.value = amountafterdiscount;

    ////console.log(amountafterdiscount);

    const filteredTaxPer =
      taxs &&
      taxs
        .filter((item) => parseInt(item.taxId) === parseInt(total.taxId))
        .map((item) => item.taxPercentage);

    var taxAmt = parseFloat((amountafterdiscount / 100) * filteredTaxPer) || 0;

    taxAmt = taxAmt.toFixed(2);

    frmRef.current.tax_amt.value = parseFloat(taxAmt);

    setTaxAmount(taxAmt);

    var totalAmt = parseFloat(taxAmt) + parseFloat(amountafterdiscount);

    frmRef.current.total_work_value.value = parseFloat(totalAmt);
  }, [total, taxs]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">
                    Add Rented Vehicle Invoice Detail
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        text={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Assigned Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                      >
                        {employeeId &&
                          employeeId.map((x) => (
                            <option value={x.empId}>{x.employeeName}</option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"vendor_name"}>{"Vendor Name"}</label>
                      <select
                        id="vendor_name"
                        className="form-control"
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                        value={vendorId}
                        onChange={(e) => {
                          // frmRef.current.vendor_id.value =
                          //   e.target.childNodes[e.target.selectedIndex].getAttribute(
                          //     "vendor-id"
                          //   );

                          setvendorId(e.target.value);
                          loadVendorData(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {vendorDetails &&
                          vendorDetails.map((x) => (
                            <option
                              key={x.vendorId}
                              vendor-id={x.vendorId}
                              value={x.vendorId}
                            >
                              {x.vendorName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"vendor_id"}>{"Vendor id"}</label>
                      <input
                        type={"text"}
                        id={"vendor_id"}
                        disabled
                        ref={(el) => (frmRef.current["vendor_id"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"vme_classification"}>
                        {"Classification"}
                      </label>
                      <select
                        id="vme_classification"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["vme_classification"] = el)
                        }
                      >
                        <option value="Vehicle">Vehicle</option>
                        <option value="Machine">Machine</option>
                        <option value="Equipment">Equipment</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"labour_transport_cost"}>
                        {"Vehicle/Machine Model Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"modal_name"}
                        required
                        ref={(el) => (frmRef.current["modal_name"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"vme_category"}>{"Category"}</label>
                      <select
                        id="vme_category"
                        className="form-control"
                        ref={(el) => (frmRef.current["vme_category"] = el)}
                      >
                        <option value="Four Tire">Four Tire</option>
                        <option value="Two Axle, Six Tire">
                          Two Axle, Six Tire
                        </option>
                        <option value="Three Axle">Three Axle</option>
                        <option value="Single Trailer">Single Trailer</option>
                        <option value="Multi Trailer">Multi Trailer</option>
                        <option value="Cleaning">Cleaning</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"vme_number"}>
                        {"Vehicle/Machine  Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"vme_number"}
                        required
                        ref={(el) => (frmRef.current["vme_number"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"manufacturing_year"}>
                        {"Manufacturing Year"}
                      </label>
                      <input
                        type={"text"}
                        id={"manufacturing_year"}
                        required
                        ref={(el) =>
                          (frmRef.current["manufacturing_year"] = el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"last_maintenance_date"}>
                        {"Last Maintenance Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"last_maintenance_date"}
                        required
                        ref={(el) =>
                          (frmRef.current["last_maintenance_date"] = el)
                        }
                        className="form-control"
                        max={currentDate}
                        value={lastMaintenanceDate}
                        text={lastMaintenanceDate}
                        onChange={handleLastMaintenanceChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"service_deal_type"}>
                        {"Service Deal Type"}
                      </label>
                      <select
                        id="service_deal_type"
                        className="form-control"
                        ref={(el) => (frmRef.current["service_deal_type"] = el)}
                      >
                        <option value="Hourly">Hourly</option>
                        <option value="Fix set of hours">
                          Fix set of hours
                        </option>
                        <option value="Work Based">Work Based</option>
                        <option value="Number of Days">Number of Days</option>
                        <option value={"Other"}>Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"rent_cost"}>{"Rent Cost"}</label>
                      <input
                        type={"text"}
                        id={"rent_cost"}
                        required
                        ref={(el) => (frmRef.current["rent_cost"] = el)}
                        className="form-control"
                        onChange={(e) =>
                          setTotalValue({ ...total, rentCost: e.target.value })
                        }
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"currency"}>{"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control"
                        ref={(el) => (frmRef.current["currency"] = el)}
                        value={currencyId}
                        onChange={(e) => {
                          setCurrencyId(e.target.value);
                        }}
                      >
                        <option>--Select--</option>

                        {currancys &&
                          currancys.map((x) => (
                            <option key={x.currencyId} value={x.currencyId}>
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"discount"}>{"Discount(%)"}</label>
                      <input
                        type={"text"}
                        id={"discount"}
                        required
                        ref={(el) => (frmRef.current["discount"] = el)}
                        className="form-control"
                        onChange={(e) =>
                          setTotalValue({
                            ...total,
                            dispercentage: e.target.value || 0,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"discount_amt"}>
                        {"Discount Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"discount_amt"}
                        required
                        ref={(el) => (frmRef.current["discount_amt"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"total_amount"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amount"}
                        required
                        ref={(el) => (frmRef.current["total_amount"] = el)}
                        className="form-control"
                        dia
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        value={taxId}
                        className="form-control"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        onChange={(e) => {
                          setTaxId(e.target.value);
                          setTotalValue({ ...total, taxId: e.target.value });
                        }}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"total_work_value"}>
                        {"Total Work service order value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_work_value"}
                        required
                        ref={(el) => (frmRef.current["total_work_value"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row"></div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      &nbsp;{" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default RentedInvoiceForm;
